'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/millisecondAgo.js
// module id = 695
// module chunks = 0